// extracted by mini-css-extract-plugin
export default {"select":"fu2AIzBMscIay2luh9IB","fadeIn":"NQihhfS6H2EYXAQFNT13"};